export default "__VITE_ASSET__BBSpkLYz__"